import { render, staticRenderFns } from "./renter_item_info_institutions.vue?vue&type=template&id=3dd6d660"
import script from "./renter_item_info_institutions.vue?vue&type=script&lang=js"
export * from "./renter_item_info_institutions.vue?vue&type=script&lang=js"
import style0 from "./renter_item_info_institutions.vue?vue&type=style&index=0&id=3dd6d660&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports